import { useEffect } from "react";
import { useStore } from "../state/store";
import { bbos, contexts, hold, type AssetCtx, type Bbo } from "./feed";

/** The live touch of `coin` on Hyperliquid, held while mounted. */
export function useBbo(coin: string | undefined): Bbo | undefined {
  useEffect(() => (coin ? hold({ type: "bbo", coin }) : undefined), [coin]);
  return useStore(bbos, (all) => (coin ? all[coin] : undefined));
}

/** The day context of `coin` (24h open, volume), held while mounted. */
export function useAssetCtx(coin: string | undefined): AssetCtx | undefined {
  useEffect(() => (coin ? hold({ type: "activeAssetCtx", coin }) : undefined), [coin]);
  return useStore(contexts, (all) => (coin ? all[coin] : undefined));
}
